import { useState, useRef } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import SaveIcon from '@mui/icons-material/Save'

interface IEditableInputProps {
  setEditInProgress: (isEdit: boolean) => void
  handleSaveInput: (newInput: string) => void
  validationPattern?: string
  invalidInputMessage?: string
}

const EditableInput = ({
  setEditInProgress,
  handleSaveInput,
  validationPattern,
  invalidInputMessage
}: IEditableInputProps) => {
  const input = useRef<HTMLInputElement>(null)
  const [isValid, setIsValid] = useState<boolean>(false)

  const keyPress = (key: string): void => {
    const stateNameDOMElement = input.current

    if (stateNameDOMElement == null) {
      return
    }

    setIsValid(stateNameDOMElement.checkValidity())

    if (key === 'Enter' && isValid) {
      handleSubmit()
    }
  }

  const handleSubmit = (): void => {
    handleSaveInput(input?.current?.value as string)
    setEditInProgress(false)
  }

  return (
    <div className='flex'>
      <input
        className='h-6 rounded-sm'
        type='text'
        ref={input}
        onKeyUp={(e) => keyPress(e.key)}
        pattern={validationPattern}
        maxLength={20}
        defaultValue=''
        required
      />
      <button
        className='disabled:opacity-50'
        onClick={handleSubmit}
        disabled={!isValid}
        title={
          isValid || invalidInputMessage == null ? '' : invalidInputMessage
        }
      >
        <SaveIcon className='pl-2 text-gray-700' />
      </button>
      <button onClick={() => setEditInProgress(false)}>
        <CloseIcon className='pl-1 text-gray-700' />
      </button>
    </div>
  )
}

export default EditableInput
